import React from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie'

function Nav() {

  const Navigate = useNavigate();
  const apiUrl = process.env.REACT_APP_API_URL;

  
  const handleLogout = async (event) => {
    event.preventDefault();
    try {
        const response = await axios.post(`${apiUrl}/deconnexion`,
            {},
            {
              withCredentials: true 
            }
          );
      if (response.data.success) {
        Cookies.remove(`token`)
        Navigate('/connexion'); 
      } else {
        console.error('Erreur lors de la déconnexion');
      }
      Navigate('/connexion'); 
    } catch (error) {
      console.error('Erreur lors de la déconnexion', error);
    }
  };

  return (
    
    <>
          <header>
            <div className="info">
              <ul className="menu">
                <li className="home"><a href="/admin" className="menu-button home">menu</a></li>
                <li className="deconnexion"><a href="/" className="deco" onClick={handleLogout}>deconnexion</a></li>
              </ul>
            </div>
          </header>
          
    </>
  )
}

export default Nav;
